import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  RequestSubscriptionDowngradeMutation,
  RequestSubscriptionDowngradeMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const requestSubscriptionDowngradeMutation = graphql(`
  mutation requestSubscriptionDowngrade($input: RequestSubscriptionDowngradeInput!) {
    requestSubscriptionDowngrade(input: $input) {
      success
    }
  }
`);

/** Asks the account's CSM to move the user to a lower plan. */
export function useDowngrade(
  options?: UseMutationOptions<
    RequestSubscriptionDowngradeMutation,
    unknown,
    RequestSubscriptionDowngradeMutationVariables,
    unknown
  >,
) {
  return useGraphQlMutation(requestSubscriptionDowngradeMutation, options);
}
